import groupingReducer from "./groupingReducers";

export * from "./groupingActions";
export default groupingReducer;
